import script from "./ButtonDelete.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonDelete.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonDelete.vue?vue&type=style&index=0&id=61cbdfb6&scoped=true&lang=css"
import "./ButtonDelete.vue?vue&type=style&index=1&id=61cbdfb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61cbdfb6"]])

export default __exports__